module.exports = __webpack_public_path__ + "public/img/7rhmtjsj.89297ba3.png";